import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { CenteredFlexBox } from '../FlexBox';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';

const TimelineStepper = function TimelineStepper({ period, onChangePeriod }) {
  const onBackClick = () => {
    if (onChangePeriod) {
      onChangePeriod('back');
    }
  };
  const onForwardClick = () => {
    if (onChangePeriod) {
      onChangePeriod('forward');
    }
  };

  return (
    <CenteredFlexBox padding="16px" justifyContent="space-between">
      <IconButton id="back-button" size="large" onClick={onBackClick}>
        <ArrowBackIosNewRoundedIcon />
      </IconButton>
      <Typography variant="h6">{period}</Typography>
      <IconButton id="forward-button" size="large" onClick={onForwardClick}>
        <ArrowForwardIosRoundedIcon />
      </IconButton>
    </CenteredFlexBox>
  );
};

export default TimelineStepper;
